import React from "react";
import styles from "./GiftTag.module.css";

const firstName = (name) => String(name || "").trim().split(" ")[0];

/** A received gift: the orders screens never show its price. */
export const isReceivedGift = (order) => order?.gift?.role === "recipient";

/** A gift this user bought for someone else: the code is not theirs to see. */
export const isSentGift = (order) => order?.gift?.role === "sender";

const GiftIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 12v9H4v-9" />
    <path d="M2 7h20v5H2z" />
    <path d="M12 21V7" />
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </svg>
);

/**
 * "Gift from Priya" on an order the viewer received, "Gift for Rahul" on one
 * they sent. Renders nothing for an ordinary order.
 */
export const GiftTag = ({ gift }) => {
  if (!gift) return null;
  const who =
    gift.role === "sender" ? firstName(gift.recipient_name) : firstName(gift.sender_name);
  const text =
    gift.role === "sender" ? (who ? `Gift for ${who}` : "Sent as a gift") : who ? `Gift from ${who}` : "Gift";
  return (
    <span className={styles.tag}>
      <GiftIcon />
      {text}
    </span>
  );
};

/** Shown once, on the screen a recipient lands on after claiming. */
export const GiftClaimedBanner = ({ claimed }) => {
  if (!claimed) return null;
  const from = firstName(claimed.sender_name);
  return (
    <div className={styles.banner} role="status">
      <span className={styles.bannerIcon}>
        <GiftIcon />
      </span>
      <span>
        <strong>It's yours.</strong>{" "}
        {claimed.brand ? `${claimed.brand}${from ? ` from ${from}` : ""} is in your orders.` : "Your gift is in your orders."}
      </span>
    </div>
  );
};

export default GiftTag;
